import React from "react";
import Text, { H3 } from "@ui/Text";
import t from "../../../../../../../i18n";
import { FullViewportTrigger } from "@ui/FullViewportButton";
import { ExportWidgetButton } from "@ui/ExportWidgetButton";
import { generateExportFileName } from "diagnostics-lib/string";
import { blockHeaderSubtitle, blockHeaderTitle } from "./_styles/BlockHeader";
import { css } from "@linaria/core";
import type { DashboardBlockModelT } from "../../../../schema/dashboard";
import { spacings } from "@ui/Theme";

interface WidgetHeaderProps {
  block: DashboardBlockModelT;
  projectName: string;
  dashboardTitle?: string;
  formattedPeriodRange?: {
    from: string;
    to: string;
    duration: string;
  };
  editable?: boolean;
  allowFullscreen?: boolean;
  analysisSelector?: React.ReactNode;
}

function isTitleObject(data: unknown): data is { title?: string } {
  return typeof data === "object" && data !== null && "title" in data;
}

export const WidgetHeader: React.FC<WidgetHeaderProps> = ({
  block,
  projectName,
  dashboardTitle,
  formattedPeriodRange,
  editable = false,
  allowFullscreen = false,
  analysisSelector,
}) => (
  <div className={plotHeader}>
    <div>
      {block.kind !== "PRESET" &&
        (isTitleObject(block.data) && block.data.title ? (
          <>
            <H3 className={blockHeaderTitle}>{block.data.title}</H3>
          </>
        ) : block.kind === "IMAGE" && typeof block.data === "string" && block.data.length > 0 ? (
          <>
            <H3 className={blockHeaderTitle}>{block.data}</H3>
            {analysisSelector}
          </>
        ) : (
          analysisSelector
        ))}
      {formattedPeriodRange && (
        <Text type="body2" className={blockHeaderSubtitle}>
          {t(
            "project.dashboard.block.period",
            formattedPeriodRange.from,
            formattedPeriodRange.to,
            formattedPeriodRange.duration,
          )}
        </Text>
      )}
    </div>
    <div>
      {analysisSelector}
      {!editable && block.kind !== "PRESET" && (
        <ExportWidgetButton
          fileName={generateExportFileName({
            filename: typeof block.data !== "string" && block.data.title ? block.data.title : "",
            projectName: (dashboardTitle ?? "") + "_" + projectName,
            extension: "png",
          })}
        />
      )}
      {allowFullscreen && !editable && <FullViewportTrigger />}
    </div>
  </div>
);

export const plotHeader = css`
  display: flex;
  margin-bottom: ${spacings.m};

  > :first-child {
    margin-right: auto;
  }
`;
